export const MAX_RATING = 5;

export const SIZE_RANGES = {
    petite: {
        min: 0,
        max: 16,
    },
    plus: {
        min: 14,
        max: 40,
    },
    regular: {
        min: 0,
        max: 18,
    },
};
